const httpErrors = [400, 401, 403];

export default function IsUserUnauthorized(status) {
  if (httpErrors.includes(status)) {
    sessionStorage.clear();
    window.location.replace("/");
  }
}
